import BaseMutations from '@/store/base/mutations'

export default BaseMutations({
  //
})